import styled, { useTheme } from "styled-components";
import { StatusCircle } from "Global/StatusCircle";
import { CSSProperties, ReactNode } from "react";
import { StatusTagStyles } from "@shared/common/Tags/styles";
import Tooltip from "common/Tooltips/Tooltip";

interface StatusTagProps {
  color?: string;
  text?: ReactNode;
  animated?: boolean;
  style?: CSSProperties;
  withBgColor?: boolean;
  isActive?: boolean;
  size?: "small";
  showText?: boolean;
  showCircle?: boolean;
  statusIcon?: ReactNode;
  tooltipContent?: string;
  mobileTooltipTitle?: string;
}

const StatusTag = ({
  color,
  text,
  style,
  animated = true,
  withBgColor = true,
  isActive,
  size,
  showText = true,
  showCircle = true,
  statusIcon,
  tooltipContent,
  mobileTooltipTitle,
}: StatusTagProps) => {
  const appTheme = useTheme();
  let tagColor = color ?? appTheme.colors.green;

  if (isActive !== undefined) {
    if (!color) {
      tagColor = isActive ? appTheme.colors.green : appTheme.colors.red;
    }
    text = isActive ? "Active" : "Inactive";
  }

  const statusTag = (
    <StatusWrapper
      $color={tagColor}
      style={style}
      $withBgColor={withBgColor}
      $size={size}
    >
      {showCircle && !statusIcon && (
        <StatusCircle
          color={tagColor}
          $animated={animated}
          style={{ marginRight: showText ? 6 : 0 }}
        />
      )}
      {statusIcon}
      {showText && text}
    </StatusWrapper>
  );

  if (tooltipContent) {
    return (
      <Tooltip
        title={tooltipContent}
        showMobileBottomDrawer={true}
        mobileTitle={mobileTooltipTitle}
      >
        {statusTag}
      </Tooltip>
    );
  }

  return statusTag;
};

export default StatusTag;

const StatusWrapper = styled.div<{
  $color: string;
  $withBgColor: boolean;
  $size?: "small";
}>`
  ${StatusTagStyles.wrapper};
`;
